import React from 'react'
import Sectiontitle from '../section-title'
import LocationMapOne from '../LocationModal1/LocationModal'
import LocationMapTwo from '../LocationModal2/LocationModal'
// import LocationMapThree from '../LocationModal3/LocationModal'
import LocationMapFour from '../LocationModal4/LocationModal'

import './style.css'

const Location = () => {
    return (


        <div id="event" className="service-area section-padding">
            <div className="container-s">
                <Sectiontitle section={'When & Where'} />
                <div className="service-area-menu">
                    <div className="Ceremony-wrap">
                        <div className="l-a">
                            <div className="cpad">
                                <div className="ceromony-img">
                                    <img src="/images/events/wedding-suit.png" alt="w" />
                                </div>
                            </div>
                            <div className="cpad">
                                <div className="ceromony-content">
                                    <h3>Ετοιμασία Γαμπρού</h3>
                                    <span>4:00 <em>μ.μ</em></span>
                                    <span>Text - τοποθεσία βίλας</span>
                                    <p>Ο γαμπρός μας θα ετοιμαστεί στην <strong>Villa 8</strong> του πολυτελούς συγκροτήματος <strong>Anthorina Villa</strong>.</p>
                                    <LocationMapOne buttonClass={'location-btn'} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="Ceremony-wrap">
                    <div className="l-b">
                    <div className="cpad">
                            <div className="ceromony-content ceromony-content2">
                            <h3>Ετοιμασία Νύφης</h3>
                            <span>5:00 <em>μ.μ</em></span>
                            {/* <span>Text - τοποθεσία σπιτιού</span> */}
                            <p>Η Νύφη μας θα ετοιμαστεί στο σπίτι των γονιών της. Είστε όλοι ευπρόσδεκτοι στο ντύσιμο της νύφης.  
                            <br/>
                            Για να φτάσετε στο Σπίτι της Νύφης, ανοίξτε το χάρτη, ο οποίος σας κατευθύνει έως το "Litsas Supermarket". Έπειτα ακολουθήστε τις Οδηγίες διαδρομής που παρατίθενται στην παρακάτω φωτογραφία</p>
                                <LocationMapTwo buttonClass={'location-btn'} />
                            </div>
                        </div>
                        <div className="cpad">
                            <div className="ceromony-img">
                            <img src="/images/events/bridal-dress.png" alt="w" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="Ceremony-wrap">
                <div className="l-a">
                <div className="cpad">
                            <div className="ceromony-img">
                            <img src="/images/events/church.png" alt="w" />
                            </div>
                        </div>
                        <div className="cpad">
                            <div className="ceromony-content">
                            <h3>Μυστήριο Γάμου</h3>
                            <span>7:00 <em>μ.μ</em></span>
                            {/* <span>Text - τοποθεσία εκκλησίας</span> */}
                            <p>Το Εξωκκλήσι Αποστόλου Βαρνάβα & Αγίας Χρυσής βρίσκεται λίγα βήματα από το Σπίτι της Νύφης. Για να φτάσετε έως εκεί, ακολουθήστε τις ίδιες Οδηγίες διαδρομής που δίνονται παραπάνω. </p>
                                {/* <LocationMapThree buttonClass={'location-btn'} /> */}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="Ceremony-wrap">
                <div className="l-b">
                <div className="cpad">
                            <div className="ceromony-content ceromony-content2">
                            <h3>Guest seated</h3>
                            <span>8:30 <em>μ.μ</em></span>
                            {/* <span>Text - τοποθεσία κέντρου</span> */}
                            <p>Κέντρο Δεξιώσεων 
                            Starlight Garden and Hall στον Πρωταρά, Κύπρος.</p>
                                <LocationMapFour buttonClass={'location-btn'} />
                            </div>
                        </div>
                        <div className="cpad">
                            <div className="ceromony-img">
                            <img src="/images/events/curtains.png" alt="w" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="Ceremony-wrap">
                <div className="l-a">
                <div className="cpad">
                            <div className="ceromony-img">
                            <img src="/images/events/dish-fork-and-knife.png" alt="w" />
                            </div>
                        </div>
                        <div className="cpad">
                            <div className="ceromony-content">
                            <h3>Δείπνο</h3>
                            <span>9:00 <em>μ.μ</em></span>
                            {/* <span>Text - τοποθεσία εκκλησίας</span> */}
                            <p>Κέντρο Δεξιώσεων 
                            Starlight Garden and Hall στον Πρωταρά, Κύπρος.</p>  {/* <LocationMap buttonClass={'location-btn'} /> */}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="Ceremony-wrap">
                <div className="l-b">
                <div className="cpad">
                            <div className="ceromony-content ceromony-content2">
                            <h3>Ο πρώτος μας χορός</h3>
                            <span>10:00 <em>μ.μ</em></span>
                            {/* <span>Text - τοποθεσία σπιτιού</span> */}
                                {/* <LocationMap buttonClass={'location-btn'} /> */}
                            </div>
                        </div>
                        <div className="cpad">
                            <div className="ceromony-img">
                            <img src="/images/events/wedding-dance.png" alt="w" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="Ceremony-wrap">
                <div className="l-a">
                <div className="cpad">
                            <div className="ceromony-img">
                            <img src="/images/events/wedding-cake.png" alt="w" />
                            </div>
                        </div>
                        <div className="cpad">
                            <div className="ceromony-content">
                            <h3>Ώρα για γλυκάκι και μην φύγετε νωρίς...</h3>
                            <span>10:30 <em>μ.μ</em></span>
                            {/* <span>Text - τοποθεσία εκκλησίας</span> */}
                            {/* <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p> */}
                                {/* <LocationMap buttonClass={'location-btn'} /> */}
                            </div>
                        </div>
                    </div>
                </div>

                    <div className="row align-items-center mt-4 ">
                        <div className="col d-flex justify-content-center align-items-center flex-column"> 
                            <img id="dance" src="/images/events/dance.png" alt="w" />
                            <p>Ας αρχίσουν οι χοροί...</p>
                            </div>
                        </div>
                </div>
            </div>
    )
}
export default Location;